import React from "react";
import { MapPin, Phone, Mail, Printer, Clock } from "lucide-react";
import { useContent } from "../contexts/ContentContext";

function InfoBlock({ icon: Icon, label, children }) {
  return (
    <div className="flex items-start gap-4">
      <Icon className="w-5 h-5 text-[#d4b87a] mt-1 shrink-0" />
      <div>
        <div className="text-xs uppercase tracking-widest text-stone-400 mb-1">{label}</div>
        {children}
      </div>
    </div>
  );
}

function OfficeCard({ office }) {
  return (
    <div className="flex items-start gap-4 p-4 border border-white/10 bg-white/5">
      <MapPin className="w-5 h-5 text-[#d4b87a] mt-1 shrink-0" />
      <div>
        <div className="text-[11px] uppercase tracking-[0.2em] text-[#d4b87a] mb-1">{office.label}</div>
        <div>{office.street}</div>
        <div>{office.city}, {office.state} {office.zip}</div>
        <a
          href={office.mapUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="text-[#a8c4dc] text-sm hover:text-white mt-1 inline-block"
        >
          Get directions &rarr;
        </a>
      </div>
    </div>
  );
}

export default function ContactInfo() {
  const { firm: FIRM_INFO } = useContent();
  return (
    <div>
      <span className="text-xs uppercase tracking-[0.3em] text-[#d4b87a]">Get in Touch</span>
      <h2 className="font-serif text-5xl md:text-6xl mt-4 leading-tight">
        Schedule a <span className="italic text-[#a8c4dc]">Consultation</span>
      </h2>
      <div className="h-px w-14 bg-[#b8924a] mt-6" />
      <p className="text-stone-300 text-lg mt-6 leading-relaxed max-w-lg">
        Whether you&rsquo;re seeking counsel on a personal matter or business need, our attorneys are ready to listen &mdash; carefully and confidentially.
      </p>

      <div className="mt-10 space-y-5 text-stone-200">
        <div>
          <div className="text-xs uppercase tracking-widest text-stone-400 mb-3">Offices</div>
          <div className="grid sm:grid-cols-2 gap-4">
            {FIRM_INFO.offices.map((o) => (
              <OfficeCard key={o.label} office={o} />
            ))}
          </div>
        </div>

        <InfoBlock icon={Phone} label="Phone">
          {FIRM_INFO.phones.map((p) => (
            <div key={p}>
              <a href={`tel:${p.replace(/\D/g, "")}`} className="hover:text-white">{p}</a>
            </div>
          ))}
        </InfoBlock>

        <InfoBlock icon={Printer} label="Fax">
          <div>{FIRM_INFO.fax}</div>
        </InfoBlock>

        <InfoBlock icon={Mail} label="Email">
          <a href={`mailto:${FIRM_INFO.email}`} className="hover:text-white">{FIRM_INFO.email}</a>
        </InfoBlock>

        <InfoBlock icon={Clock} label="Hours">
          <div>{FIRM_INFO.hours}</div>
        </InfoBlock>
      </div>
    </div>
  );
}
